<template>
  <div class="description">
    <div class="project" v-if="currentLanguage == 'EN'">
      The READ-Urban project [Robust Estimation using Aggregated Data for Urban policy making] was a collaborative research project among the Municipality of The Hague, Statistics Netherlands (CBS) as well as the Institute of Advanced Computer Science (LIACS) and the Institute of Public Administration (BSK) at Leiden University. The goal was to use a combination of traditional urban data and more dynamic sources of information to support policies for the group of working poor – citizens who are working but fall below the poverty line. In this context, one question was how data analytics can help to measure the effectiveness of urban social policy instruments by looking specifically at the usage of the The Hague 'poverty pass' in this group. Data from CBS Wijk- en Buurtkaart 2017.

      Leiden University Researchers involved: <i>From LIACS: <a href="http://liacs.leidenuniv.nl/~kraaijw/">Prof. Wessel Kraaij</a>, Dr. Jose Miotto. From BSK: <a href="https://www.universiteitleiden.nl/en/staffmembers/sarah-giest">Dr. Sarah Giest</a>. </i>

      How to cite this visualization:
      <i>BloomingData &amp; Leiden University (2019), READ-Urban Project, Data visualization.
      Available at: https://www.universiteitleiden.nl/en/research/research-projects/science/liacs-read-urban.</i>
    </div>
    <div class="project" v-if="currentLanguage == 'NL'">
      Het READ-Urban project [Robust Estimation using Aggregated Data for Urban policy making] was een gezamenlijk onderzoekstraject met de gemeente Den Haag, het Centraal Bureau voor de Statistiek (CBS), het Het Leiden Institute of Advanced Computer Science (LIACS) en het Instituut Bestuurskunde (BSK) van de Universiteit Leiden. Het doel was om tradionele stedelijke data en meer dynamische data te combineren om zo ondersteuning te bieden aan beleid voor de 'werkende armen': burgers die werken maar onder de armoedegrens leven. Een van de vragen was hoe data analyse kan helpen bij het meten van de effectiviteit van beleidsinstrumenten door te kijken naar het gebruik van de Haagse 'Ooievaarspas'. Data is afkomstig uit de CBS Wijk- en Buurtkaart 2017.

      Betrokken onderzoekers vanuit de Universiteit Leiden: <i>Vanuit LIACS: <a href="http://liacs.leidenuniv.nl/~kraaijw/">Prof. Wessel Kraaij</a>, Dr. Jose Miotto. Vanuit BSK: <a href="https://www.universiteitleiden.nl/en/staffmembers/sarah-giest">Dr. Sarah Giest</a>. </i>

      Hoe te refereren naar deze visualisatie:
      <i>BloomingData &amp; Universiteit Leiden (2019), READ-Urban Project, Data visualisatie.
      Beschikbaar op: https://www.universiteitleiden.nl/en/research/research-projects/science/liacs-read-urban.</i>
    </div>
  </div>
</template>

<style scoped>
  .description {
    flex: 1 1 auto;
    font-size: 9pt;
    color: #333333;
  }
  .project {
    flex: 0 0 auto;
  }

</style>

<script>
export default {
  computed: {
    currentLanguage() {
      return this.$store.getters.currentLanguage;
    },
  }
}
</script>
